import { JSXElement, mergeProps, Show } from 'solid-js';
import { ActionsDropdown } from '~/components/ActionsDropdown';
import { Localized } from '~/i18n';
import { getLocalizedString } from '~/i18n/utils.ts';
import { Link2Icon } from 'lucide-solid';
import {
  RedirectUriFlowTypes,
  RedirectUriType
} from '~/pages/FullStackAuthentication/Redirects/utils.tsx';

type RedirectUriItemProps = {
  redirectUri: string;
  flowType?: RedirectUriFlowTypes;
  isDefault?: boolean;
  id?: string;
  onEdit: (uri: string) => void;
  onDelete: (uri: string) => void;
  onSelectedAsDefault?: (uri: string) => void;
  type: RedirectUriType;
};

export default function RedirectUriItem(
  props: RedirectUriItemProps
): JSXElement {
  const merged = mergeProps(
    {
      isDefault: false,
      id: `redirect-uri-${new Date().getTime()}`
    },
    props
  );

  const getRedirectUriActions = () => {
    return [
      {
        label: getLocalizedString('cta_labels.edit'),
        onClick: () => merged.onEdit(merged.redirectUri)
      },
      {
        label: (
          <span class={`text-error`}>
            <Localized
              translationKey={getLocalizedString('cta_labels.delete')}
            />
          </span>
        ),
        onClick: () => merged.onDelete(merged.redirectUri)
      }
    ];
  };

  const showActions = () =>
    merged.flowType === RedirectUriFlowTypes.REDIRECTS ||
    merged.flowType === RedirectUriFlowTypes.MULTI_APPLICATION;

  return (
    <div
      class={`each-uri mb-1 py-1 w-full flex flex-wrap text-sm text-fg-muted justify-between hover:bg-bg-subtle hover:rounded-md`}
      classList={{
        'py-3': merged.flowType === RedirectUriFlowTypes.SSO_QUICK_START
      }}
    >
      <div class={`flex items-center w-[calc(100%-50px)]`}>
        <div>
          <Link2Icon
            width={20}
            strokeWidth={1}
            class={`mr-2 mt-0.5`}
          />
        </div>
        <div class={`max-w-[calc(100%-150px)] break-all`}>
          {merged.redirectUri}
        </div>
      </div>
      <Show when={showActions()}>
        <div>
          <ActionsDropdown
            id={`${merged.id}-action`}
            items={getRedirectUriActions()}
          />
        </div>
      </Show>
    </div>
  );
}
